var data = { header:{ text:"#### Error",
    closeButton:true },
  body:{ text:"The following test{{@if(it.isMultipleTests)}}s were{{#else}} was{{/if}} not added to your cart as\n{{@if(it.isMultipleTests)}}they have{{#else}}it has{{/if}} been retired. Browse our test catalog to find the most\nup to date content.\n\n{{it.invalidTestNames}}",
    postProcessingAction:"processDeprecatedTestsError" },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=deprecated_tests.esm.js.map
